import { visitaxClient, openPayClient } from "../../../configurations/Axios/Clients";
import { FirebaseRealtimeHelper } from "./useFirebaseRealTimeHelpet";
import { Database } from "firebase/database";
import { useEffect, useRef } from "react";
import { User } from "../../AuthContext/types";
import { currentDateDataBase, getTime } from "../../../configurations/Helpers/Dateshelper";
import { createDocument } from "../../../configurations/DataBase/crud";
import { logDb } from "../../../configurations/DataBase/bases";
import { isProduction } from "../../../configurations/Axios/Clients";
interface uselogsprops {
    firebaserealtime: FirebaseRealtimeHelper;
    database: Database | null
    user: User | null
}
/**
 * Attaches Axios interceptors to store failed requests and log them to Firebase.
 *
 * @param firebaserealtime - Helper for interacting with Firebase Realtime Database.
 * @param database - Firebase database instance.
 * @param user - Currently authenticated user.
 */
const uselogs = ({ firebaserealtime, database, user }: uselogsprops) => {
    const path = isProduction()?"Production":"Sandbox"
    const errorQueueRef = useRef<any[]>([]);
    const flushErrorQueue = async () => {
        console.log("Posteando peticiones muertas");
        if (firebaserealtime && errorQueueRef.current.length > 0) {
            const queueToFlush = [...errorQueueRef.current];
            // Vaciar la cola
            errorQueueRef.current = [];
            for (const errorData of queueToFlush) {
                try {
                    await firebaserealtime.pushData("Logs/"+path+"/Front/"+currentDateDataBase()+"/"+getTime(), errorData);
                } catch (err) {
                    errorQueueRef.current.push(errorData);
                }
            }
        }
    };

    const logError = async (service: string, error: any) => {
        const errorDetails = {
            advisor: user?.userName,
            terminal: user?.terminal,
            message: error.message,
            status: error.response?.status || "N/A",
            url: error.config?.url || "N/A",
            method: error.config?.method || "N/A",
            data: error.response?.data || "Sin datos",
            timestamp: new Date().toISOString(),
        };
        createDocument(errorDetails, logDb).catch((err) =>
            console.error("Error al registrar el log localmente:", err)
        );
        if (!user) return;
       
        try {
            if (firebaserealtime) {
                await firebaserealtime.pushData("Logs/"+path+"/Front/"+currentDateDataBase()+"/"+getTime(), { service, ...errorDetails });
            } else {
                errorQueueRef.current.push({ service, ...errorDetails });
            }
        } catch (firebaseError) {
            errorQueueRef.current.push({ service, ...errorDetails });
            console.error("Error al registrar en Firebase:", firebaseError);
        }
    };

    useEffect(() => {
        const handleOnline = () => {
            flushErrorQueue();
        };
        window.addEventListener("online", handleOnline);
        return () => {
            window.removeEventListener("online", handleOnline);
        };
    }, [firebaserealtime]);


    useEffect(() => {
        if (database) flushErrorQueue();
    }, [database]);

    useEffect(() => {
        if (firebaserealtime) {
            const interceptor = visitaxClient.interceptors.response.use(
                (response) => {
                    if (response.status < 200 || response.status >= 300) {
                        logError("VISITAX", response);
                    }
                    return response;
                },
                async (error) => {
                    await logError("VISITAX", error);
                    return Promise.reject(error);
                }
            );
            return () => {
                visitaxClient.interceptors.response.eject(interceptor);
            };
        }
    }, [firebaserealtime]);


    useEffect(() => {
        if (firebaserealtime) {
            const interceptor = openPayClient.interceptors.response.use(
                (response) => {
                    if (response.status < 200 || response.status >= 300) {
                        logError("OPENPAY", response);
                    }
                    return response;
                },
                async (error) => {
                    await logError("OPENPAY", error);
                    return Promise.reject(error);
                }
            );
            return () => {
                openPayClient.interceptors.response.eject(interceptor);
            };
        }
    }, [firebaserealtime]);


    return {}
}
export default uselogs;